import { ColumnsLocalStorageKey } from '@/services/columns';
import { logoutChatwootSession } from '@/services/utils/chatwoot';
import { removeAuthToken } from '@/services/api/main/axios';
import { $emitter } from '@/services/emitter';
import { useStore } from '@/store';

export const performLogoutCleanup = () => {
  logoutChatwootSession();
  window.sessionStorage.removeItem('impersonation');
  Object.keys(window.localStorage).forEach((key) => {
    if (key !== ColumnsLocalStorageKey) {
      window.localStorage.removeItem(key);
    }
  });
  useStore().resetForLogout();
  $emitter.emit('toast-clear');
  removeAuthToken();
};
